<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服工作站</el-breadcrumb-item>
        <el-breadcrumb-item @click.native="handleBack">用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <audio ref="audioElement" src="https://health-planet.oss-cn-shanghai.aliyuncs.com/1754625932005_remind1.mp3"></audio>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :before-open="beforeOpen"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="(page) => onLoad(page, params)"
      :row-style="rowStyle"
      @cell-click="handleCellClick"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>

      <template slot-scope="scope" slot="newDate">
        <el-button type="text" size="small" @click="toDataDetail(scope.row)">
          {{ scope.row.newDate }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="consult">
        <el-button type="text" size="small" @click="toHealthConsult(scope.row)" :style="{ color: scope.row.consult == 1 ? '#409EFF' : 'black' }">
          {{ scope.row.consult == 0 && scope.row.healthManager == undefined ? "--" : scope.row.consult == 1 ? "新消息" : "咨询查询" }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="digitalarchives">
        <el-button type="text" size="small" @click="digitalarchives(scope.row)">查看档案</el-button>
      </template>

      <template slot-scope="scope" slot="healthManager">
        <el-button type="text" size="small" @click="toShowHealthManager(scope.row)" style="color: black">
          {{ scope.row.healthManager || "--" }}
        </el-button>
      </template>

      <template slot-scope="scope" slot="aiWeekReport">
        <el-button type="text" size="small" @click="toGenerateAiWeekReportByUse(scope.row)">去生成</el-button>
      </template>

      <template slot-scope="scope" slot="notDistrub">
        <div :style="{ color: scope.row.notDistrub === '1' ? 'green' : '' }">
          {{ scope.row.notDistrub === "1" ? "已开启" : "未开启" }}
        </div>
      </template>

      <template slot="menu" slot-scope="{ row, index }">
        <el-button type="text" size="small" @click="toDataDetail(row, index)">查看详情</el-button>
        <el-button type="text" size="small" @click="toAddManage(row, index)">添加管理</el-button>
        <el-button type="text" size="small" @click="view(row, index)" v-if="row.isNew == 0">确认查看</el-button>
      </template>
    </avue-crud>

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="45%">
      <el-input v-model="inputValue" placeholder="请输入内容" clearable></el-input>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updateFlag">确认修改</el-button>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="pop_channel" :title="channel_title" width="50%">
      <el-select v-model="input_channel" placeholder="请选择" style="width: 100%; padding: 1vh 1 vw">
        <el-option v-for="item in channelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>

      <template #footer>
        <el-button @click="pop_channel = false">取消</el-button>
        <el-button type="primary" @click="updChannel">确认修改</el-button>
      </template>
    </el-dialog>
    <el-dialog title="请选择管理" :visible.sync="addShow" width="600px" center>
      <div class="button_addManage">
        <el-button style="font-size: 15px; margin: 5px" @click="addManage(item)" v-for="(item, index) in services" :key="index">
          {{ item.name }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="请选择管理师" :visible.sync="showHealthManager" width="40%" center>
      <div style="text-align: center">
        <el-button style="font-size: 15px; margin: 5px" @click="alterManager(item, index)" v-for="(item, index) in healthManager" :key="index" :type="item.isMy === 1 ? 'primary' : ''">
          {{ item.manager.userName }}
        </el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { getDetail } from "@/api/health/userjk";
import func from "@/util/func";
import { getUserAndDevice, view, updateFlag, getChannel, updChannel, addUserToService, getServiceDepartment, getHealthManager, alterManager, getAiWeekReportStateByUser, addAiWeekReportByUser, updateChatDate } from "@/api/health/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      username: window.localStorage.getItem("username"),
      channel: window.localStorage.getItem("channel"),
      fullscreenLoading: false,
      text: "",
      dialogVisible2: false,
      flagIndex: null,
      flagId: "",
      inputValue: "",
      dialogVisible: false,
      dialogTitle: "修改用户标签",
      pop_channel: false,
      input_channel: "",
      channel_title: "请选择用户渠道",
      headerCellClassName: "headerClass",
      params: {
        // channel: window.localStorage.getItem("channel"),
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      channelOptions: [],
      option: {
        tip: false,
        border: false,
        index: true,
        indexLabel: "序号",
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        cellEdit: true, // 启用单元格编辑
        menu: true,
        menuWidth: 190, // 初始宽度
        searchEnter: true,
        menuTitle: "处理与反馈",
        searchMenuSpan: 4,
        column: [
          {
            label: "用户ID",
            prop: "name",
            search: true,
            width: 120,
            searchSpan: 4,
            searchValue: "", // 搜索值
            type: "select", // 使用select组件，通常支持filterable
            // addDisplay: true,
            // editDisabled: false,
            dicUrl: "https://dbadmin.dbzdjk.com/admin/manage/getName",
            dicQuery: {
              channel: window.localStorage.getItem("channel") === "大白主动健康" ? null : window.localStorage.getItem("channel"),
            },
            dicMethod: "get",
            props: {
              label: "name",
              value: "name",
            },
            filterable: true, // 启用过滤功能
            clearable: false, // 可清空
            placeholder: "请输入 姓名",
            slot: true,
            reserveKeyword: true, // 关键：选择后保留关键字
            fixed: "left",
          },
          {
            label: "联系方式",
            prop: "mobile",
            search: true,
            width: 120,
            searchSpan: 4,
            fixed: "left",
          },
          {
            label: "注册时间",
            prop: "createTime",
            formatter: (row) => row.createTime.substring(0, 16),
            width: 140,
            search: true,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            dateBtn: true, // 启用日期选择按钮
            align: "center",
            fixed: "left",
          },
          {
            label: "会员级别",
            prop: "vipLevel",
            type: "select",
            search: true,
            dicData: [
              { label: "注册用户", value: 0 },
              // { label: "基础会员", value: 1 },
              { label: "体验会员", value: 2 },
              { label: "月度会员", value: 4 },
              { label: "季度会员", value: 5 },
              { label: "全年会员", value: 3 },
              { label: "vip会员", value: 6 },
              { label: "报告解读", value: 999 },
            ],
            width: 100,
            searchSpan: 4,
            fixed: "left",
          },
          {
            label: "用户标签",
            prop: "flag",
            edit: true,
            display: false,
            width: 120,
            overHidden: true,
            fixed: "left",
          },
          {
            label: "请勿打扰",
            prop: "notDistrub",
            edit: false,
            display: false,
            width: 80,
            overHidden: true,
            type: "select",
            dicData: [
              { label: "未开启", value: "0" },
              { label: "已开启", value: "1" },
            ],
            // fixed: 'left'
          },
          // {
          //   label: '用户机构',
          //   prop: 'channel',
          //   // search: this.params.channel === "大白主动健康",
          //   search: true,
          //   type: 'select',
          //   dicData: [
          //     { label: '大白主动健康', value: '大白主动健康' },
          //     { label: '大白乐康', value: '大白乐康' },
          //     { label: '永诚保险', value: '永诚保险' },
          //     { label: '泰山社区卫生服务中心', value: '泰山社区卫生服务中心' },
          //     { label: '南钢集团', value: '南钢集团' },
          //     { label: '中国石化集团共享服务有限公司南京分公司工会', value: '中国石化集团共享服务有限公司南京分公司工会' }
          //   ],
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入渠道信息'
          //     }
          //   ],
          //   minWidth: 170,
          //   searchSpan: 4
          // },
          {
            label: "数字档案",
            prop: "digitalarchives",
            // width: 180,
            minWidth: 100,
          },
          {
            label: "性别",
            prop: "sex",
            // search: true,
            type: "select",
            dicData: [
              { label: " ", value: 0 },
              { label: "男", value: 1 },
              { label: "女", value: 2 },
            ],
            width: 100,
          },
          {
            label: "年龄",
            prop: "age",
            width: 100,
            // search: true,
          },
          // {
          //   label: "身份证",
          //   prop: "card",
          //   search: true,
          //   width: 150,
          // },
          {
            label: "最新健康数据时间",
            prop: "newDate",
            // width: 180,
            minWidth: 180,
          },
          {
            label: "健康咨询",
            prop: "consult",
          },
          {
            label: "健康管理师",
            prop: "healthManager",
            // overHidden: true
          },
          {
            label: "健康积分",
            prop: "point",
            width: 100,
          },
          {
            label: "设备状态",
            prop: "bind",
            type: "select",
            dicData: [
              { label: "无设备", value: "0" },
              { label: "绑定状态", value: "1" },
            ],
            formatter: (row) => {
              if (row.bind === "1") {
                if (row.snType === "蓝牙") return `蓝牙设备`;
                else return `${row.snType || ""}`;
                // return `绑定状态 ${row.snType || ""}`;
              } else if (row.bind === "0") {
                return "无设备";
              }
              return row.bind;
            },
          },
          {
            label: "智能体类型",
            prop: "ai",
            search: true,
            type: "select",
            searchLabelWidth: 100,
            dicData: [
              { label: "大白星球", value: 1 },
              { label: "高血压数字药", value: 2 },
              { label: "减重智能体", value: 3 },
              { label: "APP端", value: 4 },
              { label: " ", value: 0 },
            ],
            searchSpan: 5,
            minWidth: 150,
          },
          {
            label: "AI周报生成",
            prop: "aiWeekReport",
            width: 100,
          },
        ],
      },
      data: [],
      timer: null,
      addShow: false,
      services: [],
      addManageRow: "",
      showHealthManager: false,
      healthManager: [],
      alterWxUserId: "",
    };
  },
  watch: {
    "option.column.0.searchValue"(newVal, oldVal) {
      console.log(`searchValue changed from ${oldVal} to ${newVal}`);
      // 在这里添加其他逻辑，例如更新UI等
    },
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  beforeRouteLeave(to, from, next) {
    const state = {
      params: { ...this.params },
      page: { ...this.page },
    };
    sessionStorage.setItem("management", JSON.stringify(state));
    next();
  },
  methods: {
    onLoad(page, params) {
      const savedState = sessionStorage.getItem("management");
      if (savedState) {
        const state = JSON.parse(savedState);
        page = state.page;
        params = state.params;
        this.page = state.page;
        this.params = state.params;
        this.option.column[0].searchValue = params.name;
        this.option.column[3].searchValue = params.mobile;
        this.option.column[4].searchValue = params.vipLevel;
        this.option.column[5].searchValue = params.createTime;
        this.option.column[7].searchValue = params.channel;
        this.option.column[10].searchValue = params.ai;
        sessionStorage.removeItem("management");
      }

      params.channel = window.localStorage.getItem("channel");
      // console.log(mask());
      getUserAndDevice(page.currentPage, page.pageSize, params).then((res) => {
        const wxUserId = window.localStorage.getItem("pcUserId");
        if (wxUserId === "2043870969731301377" && res.data.users.length > 0) {
          res.data.users.forEach((item) => {
            item.mobile = func.maskPhone(item.mobile);
            item.name = func.maskName(item.name);
          });
        }
        this.data = res.data.users;
        this.page.total = res.data.total;
        console.log("res.data.count: ", res.data.count);
        console.log(res.data.count !== "0");
        if (res.data.count !== "0") this.playOnce();
      });
      getServiceDepartment("健管部", this.channel).then((res) => {
        this.services = res.data;
        console.log("service: ", res.data);
      });
      if (this.timer == null) {
        this.startTimer();
      }
    },

    toGenerateAiWeekReportByUse(row) {
      const wxUserId = row.wxUserId;
      getAiWeekReportStateByUser(wxUserId).then((res) => {
        const state = res.data.state;
        if (state === 0) {
          addAiWeekReportByUser(wxUserId).then((res) => {
            window.alert("AI周报生成中！");
          });
        } else if (state === 1) {
          window.alert("AI周报生成中，请勿重复点击！");
        } else {
          window.alert("AI周报已生成，请勿重复点击！");
        }
      });
    },

    toHealthConsult(row) {
      console.log(row.healthManager);
      if (row.consult === 0 && row.healthManager === undefined) {
        this.$message.error("用户无健康咨询");
        return;
      }

      console.log("chatId", row.group_chat_id);

      const parameter = {
        chatId: row.group_chat_id,
        wxUserId: row.wxUserId,
      };
      console.log("row", row);
      console.log("parameter", parameter);
      updateChatDate(row.id);

      this.$router.push({
        path: "/customer/healthConsult",
        query: parameter,
      });
    },

    archiveType2(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/customer/latesthealthdata",
        query: parameter,
      });
    },

    view(row, index) {
      view(row.wxUserId).then((res) => {
        this.onLoad(this.page, this.params);
      });
    },

    handleBack() {
      // 如果有来源页面，则返回到来源页
      if (this.$route.query.from) {
        this.$router.push(this.$route.query.from);
      } else if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },

    rowStyle({ row, rowIndex }) {
      if (row.isNew === "0") {
        return {
          color: "#1890ff",
        };
      }
    },

    searchChange(params, done) {
      // params.channel = window.localStorage.getItem("channel");
      // console.log(params)
      this.params = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    searchReset() {
      this.params = {
        // channel: window.localStorage.getItem("channel"),
      };
      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data;
        });
      }
      done();
    },

    datashow(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/customer/datashow",
        query: parameter,
      });
    },

    handleCellClick(row, column, cell, event) {
      const key = column.columnKey;
      if (key === "flag") {
        this.dialogVisible = true;
        this.inputValue = row.flag;
        this.flagId = row.wxUserId;
      }
      if (key === "channel") {
        this.pop_channel = true;
        this.input_channel = row.channel;
        this.flagId = row.wxUserId;
        getChannel().then((res) => {
          this.channelOptions = res.data;
        });
      }
    },

    updateFlag(row) {
      if (this.inputValue === "") {
        this.inputValue = " ";
      }
      updateFlag(this.flagId, this.inputValue).then((res) => {
        this.dialogVisible = false;
        if (res.success) {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        }
      });
    },

    updChannel(row) {
      this.pop_channel = false;
      updChannel(this.flagId, this.input_channel).then((res) => {
        this.onLoad(this.page, this.params);
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      });
    },

    myTask() {
      getUserAndDevice(this.page.currentPage, this.page.pageSize, this.params).then((res) => {
        const wxUserId = window.localStorage.getItem("pcUserId");
        if (wxUserId === "2043870969731301377" && res.data.users.length > 0) {
          res.data.users.forEach((item) => {
            item.mobile = func.maskPhone(item.mobile);
            item.name = func.maskName(item.name);
          });
        }
        this.data = res.data.users;
        this.page.total = res.data.total;
        if (res.data.count !== "0") this.playOnce();
      });
    },

    startTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(this.myTask, 30000);
    },

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    beforeDestroy() {
      // 组件销毁前清除定时器，防止内存泄漏
      this.stopTimer();
    },

    playOnce() {
      const audio = this.$refs.audioElement;
      audio.currentTime = 0; // 初始0秒
      audio.loop = false; // 不循环
      audio.play().catch((e) => {
        console.log("播放失败:", e);
        this.remind();
      });
    },

    remind() {
      const loading = this.$loading({
        lock: true,
        text: "请点击屏幕任意区域，开启铃声",
        spinner: "el-icon-message-solid",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const closeLoading = () => {
        loading.close();
        document.removeEventListener("click", closeLoading); // 移除监听
      };
      document.addEventListener("click", closeLoading);
    },

    toAddManage(row, index) {
      this.addShow = true;
      this.addManageRow = row;
    },

    addManage(item) {
      // this.addShow = false
      if (this.addManageRow.wxUserId) {
        const serviceAndUser = {
          wxUserId: this.addManageRow.wxUserId,
          pcUsername: item.name,
        };
        addUserToService(serviceAndUser).then((res) => {
          if (res.success) this.$message.success(item.name + ": " + res.msg);
          else this.$message.error(item.name + ": " + res.msg);
        });
      }
    },

    toDataDetail(row, index) {
      const parameter = {
        wxUserId: row.wxUserId,
        imei: row.sn,
        snType: row.snType,
      };
      this.$router.push({
        path: "/customer/dataDetail",
        query: parameter,
      });
    },

    alterManager(item, index) {
      alterManager(item.isMy, item.manager.wxUserId, this.alterWxUserId).then((res) => {
        if (res.success) {
          if (this.healthManager[index].isMy === 0) {
            this.$message.success("新增成功");
            this.healthManager[index].isMy = 1;
          } else {
            this.$message.error("删除成功");
            this.healthManager[index].isMy = 0;
          }
          this.onLoad(this.page, this.params);
        }
      });
    },

    toShowHealthManager(row) {
      console.log(row);
      this.alterWxUserId = row.wxUserId;
      console.log(this.channel);
      getHealthManager(row.wxUserId, this.channel).then((res) => {
        this.healthManager = res.data;
        this.showHealthManager = true;
        console.log(res.data);
      });
    },

    digitalarchives(row) {
      console.log(row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/customer/digitalarchives",
        query: parameter,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}

.button_addManage {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  padding: 10px;
}
</style>
